import React, { useState } from 'react';
import { ThemeProvider } from 'styled-components';
import ChatBot from 'react-simple-chatbot';

const theme = {
  background: '#f5f8fb',
  headerBgColor: '#EF6C00',
  headerFontColor: '#fff',
  headerFontSize: '15px',
  botBubbleColor: '#EF6C00',
  botFontColor: '#fff',
  userBubbleColor: '#fff',
  userFontColor: '#4a4a4a',
  width: '1000px'
};

const Chat = () => {

  const [clear, setClear] = useState(false);

  const handleClear = () => {
    setClear(true, () => {
      setClear(false);
    });
  }

  const steps = [
    {
      id: '1',
      message: 'Hola! Soy Voolkia Bot. Estoy para ayudarte. Que puedo hacer por vos hoy?',
      trigger: '2',
    },
    {
      id: '2',
      options: [
        { value: 2, label: 'Soporte', trigger: '12' },
        { value: 3, label: 'Beneficios', trigger: '7' },
        { value: 5, label: 'Referidos', trigger: '9' },
        { value: 6, label: 'Solicitudes', trigger: '10' },
        { value: 8, label: 'Otros', trigger: '11' },
        { value: 9, label: 'Salir', trigger: '4' },
      ],
    },
    {
      id: '3',
      options: [
        // { value: 1, label: 'Volver al Inicio', trigger: '2' },
        // { value: 1, label: 'Volver al Inicio', trigger: () => {handleClear()} },
        { value: 1, label: 'Volver al Inicio', trigger: () => {window.location.reload()} },
        { value: 2, label: 'Salir', trigger: '4' },
      ],
    },
    {
      id: '4',
      message: 'Gracias por contactarte',
      end: true,
    },
    {
      id: '12',
      component: (
        <div>Si necesitas ayuda con tus equipos, envia tu consulta/reclamo a: <a href="mailto:infraestructura@voolkia.com">infraestructura@voolkia.com</a> y nos comunicaremos a la brevedad</div>
      ),
      trigger: '3',
    },
    {
      id: '6',
      component: (
        <div>Completa tu planilla de vacaciones desde la App Turecibo o ingresa a: <a href="https://turecibo.com/" target="_blank">turecibo.com</a> y envia un mail a <a href="mailto:ppc@voolkia.com">ppc@voolkia.com</a></div>
      ),
      trigger: '3',
    },
    {
      id: '7',
      component: (
        <div><p>Podes consultar como acceder a tus beneficios por ser empleado Voolkia, enviando un mail a <a href="mailto:ppc@voolkia.com">ppc@voolkia.com</a></p>
        <p><i><b>Queres ver algunos beneficios</b></i></p>
        <p><a href="https://www.educacionit.com/" target="_blank">Educaci&oacute;n IT</a> - 10% de descuento en todos sus cursos</p>
        <p><a href="https://www.openenglish.com/" target="_blank">Open English</a> - capacitate con descuentos exclusivos</p>
        <p><a href="https://uai.edu.ar/" target="_blank">Universidad Abierta Interamericana</a> - 20% de descuento en Maestr&iacute;as y Especializaciones</p>
        <p><a href="https://www.palermo.edu/ingenieria/" target="_blank">Universidad de Palermo</a> - 15% de descuento en carreras de grado de la Facultad de Ingenier&iacute;a</p>
        <p><a href="https://www.uade.edu.ar/" target="_blank">UADE</a> - 15 % de descuento en carreras de grado, tecnicaturas, cursos y posgrados</p>
        <p>Plataforma <a href="https://voolkia.it/wp/login/" target="_blank">Voolkia University</a> - capacitaci&oacute;n avanzada en IT</p>
        <p>Programas de Capacitaci&oacute;n seg&uacute;n tu Rol</p>
        <p>Charlas sobre temas de actualidad a cargo de profesionales</p>
        <p>Celebraci&oacute;n: Obsequios (nacimiento/graduaci&oacute;n/casamiento/cumplea&ntilde;os/aniversario dentro de la compa&ntilde;&iacute;a)</p>
        <p>Licencias por paternidad extendida (4 d&iacute;as)</p>        
        <p>Descuentos en productos <a href="https://bimboclubdebeneficios.com/" target="_blank">Bimbo Club de Beneficios</a></p>
        <p>Descuentos en productos a trav&eacute;s de <a href="https://clubdebeneficios.com/?gclid=Cj0KCQjw2tCGBhCLARIsABJGmZ7CuHjhk74OCeThfDlP7KhfmtgQE3FUbYCkU4lCHmdYyfXjzv_7c8AaAtwsEALw_wcB" target="_blank">Club de Beneficios</a></p>
        <p>Planes especiales en <a href="https://www.movistar.com.ar/" target="_blank">Movistar</a> por ser empleado Voolkia</p>
        <p>Descuento 10% para compras en <a href="https://www.staples.com.ar/" target="_blank">Staples</a></p>
        <p>Descuento 20% en <a href="https://megatlon.com.ar/#/" target="_blank">Megatlon</a> para empleado y familiares, envi&aacute; un mail con tu Nombre, DNI y tel&eacute;fono a <a href="mailto:afinidad@megatlon.com.ar?subject=Info Beneficio por EmpresaMail">afinidad@megatlon.com.ar</a></p>
        <p>Premio por Plan de Referidos</p>
        <p><a href="https://www.bancogalicia.com/" target="_blank">Banco Galicia</a> paquete de bienvenida por apertura de cuenta sueldo</p>
        </div>
      ),
      trigger: '3',
    },
    {
      id: '8',
      component: (
        <div><p>Las licencias siempre se solicitan e informan v&iacute;a correo electr&oacute;nico al referente de RRHH acompa&ntilde;&aacute;ndolo de los documentos o certificados correspondientes</p>
        <p>Examen: 2 d&iacute;as corridos por examen con un m&aacute;ximo de 10 d&iacute;as por a&ntilde;o calendario</p>
        <p>Mudanza: 2 d&iacute;as por a&ntilde;o (1 de ellos otorgado como beneficio por Voolkia)</p>
        <p>Matrimonio: 10 d&iacute;as corridos</p>
        <p>Nacimiento: 4 d&iacute;as (2 de ellos otorgados como beneficio por Voolkia)</p>
        <p>Fallecimiento: Fallecimiento de esposa, concubina, hijos y padres: 3 días corridos. Por fallecimiento de hermano: 1 día. </p>
        <p>Enfermedad: Enviar consulta a <a href="mailto:ppc@voolkia.com">ppc@voolkia.com</a></p></div>
      ),
      trigger: '3',
    },
    {
      id: '9',
      component: (
        <div><p>Para participar del Plan Referidos, envianos el CV de tu referido a <a href="mailto:seleccioncv@voolkia.com">seleccioncv@voolkia.com</a> y lo evaluaremos. Ayudanos a sumar colaboradores al Team Voolkia y ganate un premio!</p></div>
      ),
      trigger: '3',
    },
    {
      id: '10',
            options: [
        { value: 1, label: 'Adelantos de Sueldos', trigger: '18' },
        { value: 2, label: 'Licencias', trigger: '8' },
        { value: 3, label: 'Vacaciones', trigger: '6' },
        { value: 4, label: 'Recibo de Sueldos', trigger: '19' },
        { value: 5, label: 'Salir', trigger: '4' },
      ],
      trigger: '3',
    },
    {
      id: '11',
      options: [
        { value: 1, label: 'Cambio de Prepaga', trigger: '13' },
        { value: 2, label: 'Cambio de Domicilio', trigger: '14' },
        { value: 3, label: 'F572', trigger: '15' },
        { value: 4, label: 'F1357', trigger: '16' },
        { value: 5, label: 'Renuncia', trigger: '17' },
        { value: 6, label: 'Volver al Inicio', trigger: () => {window.location.reload()} },
        { value: 7, label: 'Salir', trigger: '4' },
      ],
    },
    {
      id: '13',
      component: (
        <div><p>Para cambiar de prepaga te debes contactar con tu People Care enviando un mail a <a href="mailto:ppc@voolkia.com?subject=Cambio de Prepaga">ppc@voolkia.com</a></p></div>
      ),
      trigger: '3',
    },
    {
      id: '14',
      component: (
        <div><p>Debes ingresar a <a href="https://turecibo.com/" target="_blank">turecibo.com</a> y completar la <b><i>"DDJJ de Domicilio"</i></b>, luego informar al siguiente mail <a href="mailto:ppc@voolkia.com?subject=DDJJ Cambio de Domicilio">ppc@voolkia.com</a></p></div>
      ),
      trigger: '3',
    },
    {
      id: '15',
      component: (
        <div>
        <p>El <b>formulario 572</b> le permite al trabajador informar los conceptos a deducir del <b><i>Impuesto a las Ganancias</i></b>, las percepciones que le hubieren practicado e informar otros ingresos en caso de pluriempleo</p>
        <p>El <b>SiRADIG</b> es el Sistema de Registro y Actualizaci&oacute;n de Deducciones del Impuesto a las Ganancias que permite a los empleados transmitir a sus empleadores la informaci&oacute;n correspondiente de manera electr&oacute;nica y automatizada</p>
        <p>Se accede con una clave fiscal nivel 3 o superior desde la p&aacute;gina de <b><i>AFIP</i></b> Opci&oacute;n <b><i>Siradig Trabajador</i></b></p>
        <p>En este link podes acceder a mas informaci&oacute;n <a href="https://www.afip.gob.ar/572web/#ver" target="_blank">AFIP SiRADIG</a></p>
        </div>
      ),
      trigger: '3',
    },
    {
      id: '16',
      component: (
        <div>
        <p>El <b>formulario 1357</b> es aquel utilizado para la declaraci&oacute;n de la liquidaci&oacute;n del impuesto a las ganancias anual en cuarta categor&iacute;a (la que corresponde a la relaci&oacute;n de dependencia de un trabajador con su empleador).  Si tenes alguna consulta podes hacerlo enviando un mail a <a href="mailto:ppc@voolkia.com?subject=Consulta Formulario 1357">ppc@voolkia.com</a></p>
        </div>
      ),
      trigger: '3',
    },
    {
      id: '17',
      component: (
        <div>
        <p>El telegrama de renuncia puede ser enviado en el mismo momento que le notifica a su referente de RRHH la renuncia, enviando un mail a <a href="mailto:ppc@voolkia.com">ppc@voolkia.com</a></p>
        <p><b>Datos para completar el telegrama</b></p>
        <p>Raz&oacute;n Social: Voolkia S.A.</p>
        <p>Direcci&oacute;n: Patagones 2665 Piso 1, Dpto A, Parque Patricios, CABA</p>
        <p>C&oacute;digo Postal: 1437</p>
        <p>CUIT: 30-70889460-1</p>
        <p>Fecha de renuncia: <b>&Uacute;ltimo d&iacute;a trabajado</b></p>
        </div>
      ),
      trigger: '3',
    },
    {
      id: '18',
      component: (
        <div>
          <p>
            Se pueden solicitar hasta 3 anticipos de sueldo por año. <br />
            Cada uno de ellos no podrá superar el 50% de su sueldo neto. <br />
            La solicitud del mismo se debe realizar a enviando un mail con el pedido a tu People Care: <a href="mailto:ppc@voolkia.com?subject=Adelanto de Sueldo">ppc@voolkia.com</a>,  antes del día 15 de cada mes.
          </p>
        </div>
      ),
      trigger: '3',
    },
    {
      id: '19',
      component: (
        <div><p>Para obtener tu recibo de sueldo, ingresar a la App <a href="https://turecibo.com/" target="_blank">Turecibo.com</a> y descargarlo</p></div>
      ),
      trigger: '3',
    },

  ];

  return(
    clear ? <div /> :
    <div>
      <ThemeProvider theme={theme}>
        <ChatBot
          steps={steps}
          width={"60vh"} height={"90vh"}
          floating={false}
          floatingStyle={{
          left: 'calc(50% - 28px)',
          right: 'initial',
          transformOrigin: 'bottom center',
          borderRadius: 0,
          }}
          style={{
             left: 'calc(35%)',
           }}
         />
      </ThemeProvider>
    </div>
  )
}
export default Chat;